var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"overflow-hidden",attrs:{"id":"app"}},[(_vm.isLoaded)?[(!_vm.error)?_c('Layout'):_c('Error'),(!_vm.error)?_c('Dialog'):_vm._e()]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }